import React, { useRef, useState, useEffect } from 'react';
import Hls from 'hls.js';

const VideoPlayerHls = ({ videoStreaming, deviceType, nomeDispositivo, videoStreamingName }) => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState('');
  const [reloadTrigger, setReloadTrigger] = useState(false);
  const [isPictureInPictureActive, setIsPictureInPictureActive] = useState(false);

  useEffect(() => {
    const updateVideoSrc = () => {
      let newVideoSrc = '';
      switch (deviceType) {
        case 'ElicotteroH265':
        case 'ElicotteroH264':
          newVideoSrc = `${videoStreaming}/${nomeDispositivo}/${videoStreamingName}/index.m3u8`;
          break;
        case 'Drone':
          newVideoSrc = `${videoStreaming}/${nomeDispositivo}/index.m3u8`;
          break;
        case 'Barca':
          // newVideoSrc = `${videoStreaming}/${nomeDispositivo}/index.m3u8`;
          
          /*
          livestreaming.hightek.it/ecodrone/MGEC0001/stream0/
          livestreaming.hightek.it/ecodrone/MGEC0001/stream1/
          livestreaming.hightek.it/ecodrone/MGEC0001/stream2/
          livestreaming.hightek.it/ecodrone/MGEC0001/stream3/ 
          */

          newVideoSrc = `DA-GESTIRE/index.m3u8`;
          break;
        default:
          console.warn(`Tipo dispositivo non riconosciuto o URL base mancante: ${deviceType}`);
          newVideoSrc = '';
      }
      setVideoSrc(newVideoSrc);
    };

    if (videoStreaming && nomeDispositivo && deviceType) {
      updateVideoSrc();
    } else {
      setVideoSrc('');
    }

  }, [videoStreaming, deviceType, nomeDispositivo, videoStreamingName]);

  //console.log("videoSrc [URL VIDEO]: " , videoSrc);

  useEffect(() => {
    let hls = null;
    let reloadTimeoutId = null;
    let loadedMetadataHandler = null;

    const initializeHls = () => {
      if (!videoSrc) return;

      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(videoRef.current);

        hls.on(Hls.Events.ERROR, function (event, data) {
          if (data.fatal) {
            console.error('Errore fatale durante il caricamento del video:', data.type, data.details);
            
            if (data.type !== Hls.ErrorTypes.NETWORK_ERROR || data.details !== Hls.ErrorDetails.MANIFEST_PARSING_ERROR) {
              if (reloadTimeoutId) {
                clearTimeout(reloadTimeoutId);
              }
              console.warn('[VideoPlayerHls] Tento reload dopo errore fatale...');
              reloadTimeoutId = setTimeout(() => {
                //console.log('[VideoPlayerHls] Eseguo reload triggerato da timeout');
                setReloadTrigger(prevState => !prevState)
              }, 5000);
            }
          }
        });

        // PRE OTTIMIZZAZIONE
        // hls.on(Hls.Events.MANIFEST_PARSED, function () {
        //   if (videoRef.current) {
        //     videoRef.current.addEventListener('loadedmetadata', () => {
        //       playVideo();
        //     });
        //   }
        // });

        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          if (videoRef.current) {
            loadedMetadataHandler = () => {
              playVideo();
            };
            videoRef.current.addEventListener('loadedmetadata', loadedMetadataHandler);
          }
        });
        

      } else {
        console.error('Questo browser non supporta HLS');
      }
    };

    const playVideo = () => {
      if (videoRef.current) {
        const playPromise = videoRef.current.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            if (isPictureInPictureActive) {
              videoRef.current.requestPictureInPicture().catch(error => {
                console.error('Errore durante la riattivazione del Picture-in-Picture:', error);
              });
            }
          }).catch(error => {
            console.error('Errore durante la riproduzione automatica:', error);
          });
        }
      }
    };

    const handleLeavePictureInPicture = () => {
      setIsPictureInPictureActive(false);
      setTimeout(playVideo, 200);
    };

    const handleEnterPictureInPicture = () => {
      setIsPictureInPictureActive(true);
    };

    initializeHls();

    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener('leavepictureinpicture', handleLeavePictureInPicture);
      videoElement.addEventListener('enterpictureinpicture', handleEnterPictureInPicture);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('leavepictureinpicture', handleLeavePictureInPicture);
        videoElement.removeEventListener('enterpictureinpicture', handleEnterPictureInPicture);
        videoElement.pause();
        videoElement.removeAttribute('src');
        videoElement.load();
      }

      // OTTIMIZZAZIONE
      if (videoRef.current && loadedMetadataHandler) {
        videoRef.current.removeEventListener('loadedmetadata', loadedMetadataHandler);
        loadedMetadataHandler = null; // opzionale ma buono per chiarezza
      }

      if (hls) {
        hls.destroy();
      }
      if (reloadTimeoutId) {
        clearTimeout(reloadTimeoutId);
        //console.log('[VideoPlayerHls] Timeout di reload cancellato durante cleanup.');
      }
    };
  }, [videoSrc, reloadTrigger, isPictureInPictureActive]);

  return (
    <video
      autoPlay
      controls
      ref={videoRef}
      className="custom-video-player-pc"
      key={reloadTrigger}
    ></video>
  );
};

export default VideoPlayerHls;